import React, { useCallback, useEffect } from "react"
import { registerGlobalFunction } from "~/components/api/register"
import { CloudProviderType } from "~/components/cloud-provider/CloudProviderTypes"
import { useCloudProviderContext } from "~/components/cloud-provider/hooks/useCloudProviderContext"
import { usePageSession } from "~/hooks/usePageSession"

/*
Usage example:

api.openCloudProviderModal({cloudProvider: "verizon-cloud"})
*/

interface Props {}

const FuncOpenCloudProviderModal: React.FC<Props> = () => {
  const {
    pageSession: { isReady },
  } = usePageSession()
  const { openCloudProviderModal, setCurrentCloudProvider } =
    useCloudProviderContext()

  const handleOpenCloudProviderModal = useCallback(
    (data: { cloudProvider?: CloudProviderType }) => {
      const { cloudProvider = "your-device" } = data

      if (isReady) {
        if (cloudProvider) {
          setCurrentCloudProvider(cloudProvider)
        }
        openCloudProviderModal()
      }
    },
    [isReady, openCloudProviderModal, setCurrentCloudProvider]
  )

  useEffect(() => {
    if (window) {
      registerGlobalFunction(
        "openCloudProviderModal",
        handleOpenCloudProviderModal
      )
    }
  }, [handleOpenCloudProviderModal])

  return null
}

export default FuncOpenCloudProviderModal
